const telefoneutilRoutes = [
  {
    path: '/telefonesuteis',
    name: 'telefoneutil-list',
    component: () => import('@/views/telefoneutil/TelefoneUtilDashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Telefones Úteis', active: true },
      ],
    },
  },
]

export default telefoneutilRoutes
